module.exports = __webpack_public_path__ + "img/introduction_size_one@2x.062733e1.png";